
const AppSettings = {
  connectionString: "https://inmobiliariamonicatejada.com",
  version: "2.0.0"
};

export default AppSettings;
